import { Flex, Heading, Text, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { DetailedUser, EditUser, UserProperties } from 'BrokerTsLib/src/dtos'
import type {
  ModelState} from 'brokertslib/src/dtos/Shared/ModelState'
import {
  BadRequestError
} from 'brokertslib/src/dtos/Shared/ModelState'
import {
  useCreateUser,
  useGetOrganizationUnitById
} from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'

import { Container } from '@/components/Container'
import { Section } from '@/components/Section'
import { PageContent } from '@/containers/PageContent'
import { OrganizationLink } from '@/containers/shared/OrganizationLink'
import { UserEditForm } from '@/containers/users/UserEditForm'

export const OrganizationCreateUserPage = () => {
  const { organizationUnitId: organizationUnitIdParam } = useParams()
  const navigate = useNavigate()
  const toast = useToast()
  const organizationUnitId = Number(organizationUnitIdParam)

  const { data: organizationData } = useGetOrganizationUnitById(organizationUnitId)
  const organization = organizationData?.data

  const [user, setUser] = useState<DetailedUser | null>(null)
  const [properties] = useState({} as UserProperties)

  useEffect(() => {
    if (!organizationData) return

    setUser({
      insuringAllowed: true,
      valid: true,
      organizationUnitId
    } as EditUser)
  }, [organizationData,])

  const { mutateAsync: create } = useCreateUser()

  const onSubmit = (values: EditUser) =>
    create(values)
      .then(() => {
        navigate('/organization/' + organizationUnitId)
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 400)
          return new BadRequestError(e.response?.data as ModelState<EditUser>)

        toast({
          title: 'Chyba při vytváření uživatele',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        return e.cause ?? new Error('Unknown error')
      })

  return (
    <Section>
      <Container>
        <PageContent>
          <Heading>Vytvořit nového uživatele</Heading>

          <Flex display={'flex'}>
            <Text>Organizace:&nbsp;</Text>
            <OrganizationLink name={organization?.name} id={organization?.id} />
          </Flex>

          {user && organization && (
            <UserEditForm
              user={user}
              properties={properties}
              onSubmit={onSubmit}
              isCreate={true}
              organization={organization}
            />
          )}
        </PageContent>
      </Container>
    </Section>
  )
}
